export default (name) => {
  const nameArray = name.split(' ');
  const newNameArray = nameArray.map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
  return newNameArray.join(' ');
};
